import Layout from "../components/layout/Layout";
import Home from "../pages/frontend/Home";
// import Contact from "../pages/frontend/Contact";
import About from "../pages/frontend/About";
import Partner from "../pages/frontend/Partner";
import NotFound from "../pages/frontend/NotFound";
import { createBrowserRouter } from 'react-router-dom';

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />
      },
      {
        // path: "partner",
        element: <Partner />,
        path: "partner/:partner_name",
        // errorElement: <PartnerError/>,
        // loader: careerDetailsLoader,
      },
      {
        path: "about",
        element: <About />
      },
      // {
      //   path: "contact",
      //   element: <Contact />
      // },
      {
        path: "*",
        element: <NotFound />
      }
    ]
  }
]);
